import {
    OPEN_LOADER,
    CLOSE_LOADER,
    CLOSE_MODAL,
    SHOW_MODAL
} from "./types";

export default {
    state: {
        title: '',
        show_spinner: false,
        modal: {
            type: 'success',
            message: '',
            show: false
        }
    },
    actions: {
        changeTitle(context, title) {
            context.commit('changeTitle', title)
        }
    },
    mutations: {
        changeTitle(state, payload) {
            state.title = payload;
        },
        [OPEN_LOADER](state) {
            state.show_spinner = true;
        },
        [CLOSE_LOADER](state) {
            state.show_spinner = false;
        },
        [SHOW_MODAL](state, payload) {
            state.modal.type     = payload.type;
            state.modal.message  = payload.message;
            state.modal.show     = true;
        },
        [CLOSE_MODAL](state) {
            state.modal.show = false;
        }
    }
}
